// extracted by mini-css-extract-plugin
export default {"container":"styles_container__aJ+Xl","title":"styles_title__I9HOx"};